// extracted by mini-css-extract-plugin
export var infoRow = "_ky-2";
export var labelContainer = "_ky-0";
export var rightInfo = "_ky-1";